import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBTable,
  MDBTableHead,
  MDBTableBody


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';
import Popup from '../../Popup/popUp';


function CriarCheckin() {
  const navigate = useNavigate(); 
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/checkin')
  const apiAluno = require('../../../apis/aluno')
  
  const [data, setData] = useState([]);

  const [matriculaResponsavel, setMatriculaResponsavel] = useState("");

  const [alunosMarcados, setAlunosMarcados] = useState([]);

  const [botoesDesabilitados, setBotoesDesabilitados] = useState([]);

  const handleClick = async(obj) => {
    //console.log(obj);
    setBotoesDesabilitados((prevState) => {
      const novosBotoesDesabilitados = [...prevState];
      novosBotoesDesabilitados[obj.id] = true;
      return novosBotoesDesabilitados;
    });
    
    setAlunosMarcados((prevState) => [...prevState, obj]);
    
  }

  const handleSubmit = async () => {
    const today = util.getMySQLDate();
    util.isSubmitting();
  
    for (const objeto of alunosMarcados) {
      try {
        const objReq = {
          idAluno: objeto.ra,
        };
  
        const ultimaDataCheckin = await api.ultimoCheckin(objReq);
  

        console.log(ultimaDataCheckin[0])
        if (ultimaDataCheckin[0] !== undefined ? ultimaDataCheckin[0].dataformatada == today : false) {
          toast.warning(`Check-in para ${objeto.nomealuno} já foi feito hoje.`);
          handlePopupClose();
        } else {
          const obj = {
            responsavel: objeto.nome_responsavel,
            aluno: objeto.nomealuno,
            turma: objeto.codturma,
            data: today,
            dataConfirmacao: today,
            idAluno: objeto.ra,
            idResponsavel: matriculaResponsavel,
            idTurma: objeto.codturma,
            idFilial: objeto.idfilial,
            idEscola: objeto.idescola,
          };
          const result = await api.registrarCheckinApi(obj);
          console.log(obj)
          if (result) {
            toast.success(`Check-in para ${objeto.nomealuno} informado!`);
            handlePopupClose();
          } else {
            toast.error(`Erro ao fazer check-in para ${objeto.nomealuno}!`);
          }
        }
      } catch (error) {
        console.error("Erro durante a chamada da API:", error);
        toast.error("Erro ao fazer check-in!");
      }
    }
  
    util.isSubmitting();
  };

  /*const handleSubmit = () => {
    const today = util.getMySQLDate();
    util.isSubmitting()
    alunosMarcados.forEach(async objeto => {
      const obj = ({
        responsavel: alunosMarcados[0].nomeResponsavel,
        aluno: objeto.nomealuno,
        turma: objeto.codturma,
        data: util.getDate(),
        idAluno: objeto.id,
        idResponsavel: objeto.matricularesponsavel,
        idTurma: objeto.codturma,
        idFilial: objeto.idfilial,
        idEscola: objeto.idescola
      })
      const result = await api.registrarCheckinApi(obj);
      if(result){
        toast.success(`Checkin para ${objeto.nomealuno} informado!`)
        handlePopupClose()
      }else{  
        toast.error("Error ao fazer checkin!")
      }
    })
    ;
    
    
    util.isSubmitting()
    
  }*/

  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = async () => {
    const getAlunos = async () => {
      try {
        const object = {
          cpf: matriculaResponsavel,
          idFilial: userLogin.idfilial
        };
        console.log(object);
        const response = await apiAluno.pegarAlunoPorResponsavelApi(object);
        const data = await response;
        console.log(data);
        if (data === false){
          toast.error("Error ao fazer checkin!")
          return false;
        }
        else{setData(data);}
        console.log(data);
        
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    const result = await getAlunos();
    if (result !== false){
      setShowPopup(true)
    }
    

  };

  const handlePopupClose = () => {
    setShowPopup(false);
    setAlunosMarcados([]);
    setData([]);
    setBotoesDesabilitados([]);
    setMatriculaResponsavel("");
  };
  

  const [formValue, setFormValue] = useState({
    responsavel: '',
    aluno: '',
    turma: '',
    data: '',
    idAluno: '',
    idResponsavel: '',
    idTurma: '',
    idFilial: '',
    idEscola: ''
  });
  

  const onChange = (e) => {
    setMatriculaResponsavel(e.target.value);

  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'100%'}} feedback='Por favor digite a matricula do responsável' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Matricula do responsável' id='formControMatriculaResponsavel' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='matriculaResponsavel'
                          value={matriculaResponsavel || ''}
                          onChange={onChange}
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <Popup show={showPopup} handleClose={handlePopupClose}>

                        <div className='d-flex justify-content-center flex-column align-items-center w-100'>
                          {data.map((user) => (
                            <div className='d-flex justify-content-between m-2 flex-row align-items-between w-100' key={user.id}>
                              <MDBInput 
                                className='w-100 bg-dark'
                                labelClass='text-white' 
                                label='Nome do aluno' id='formControNomeAluno' 
                                type='text' 
                                size="lg" 
                                style={{color:"white", opacity:0.6}}
                                name='nomeAluno'
                                value={user.nomealuno}
                                required
                                disabled={true}
                                minLength={3}
                              
                              />
                              <MDBBtn 
                              className='btn-home w-50'
                              size='sm'
                              outline 
                              type='button'
                              color='white' 
                              onClick={() => handleClick(user)}
                              disabled={botoesDesabilitados[user.id]}
                              >Marcar</MDBBtn>
                            </div>
                          ))}
                          
                        </div>
                        <MDBBtn 
                            className='btn-home mt-5 w-100'
                            size='lg'
                            outline 
                            color='white' 
                            type='submit'
                          >Checkin</MDBBtn>
                          
                          </Popup>
                    </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='button'   
                        id='submitForm'
                        disabled={!matriculaResponsavel}  
                        onClick={handleButtonClick}
                        >
                        
                        Buscar
                      </MDBBtn>
                      
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        id='submitForm'
                        onClick={() => {
                          navigate("/area-checkin")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                    
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarCheckin;